"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventVideoStatus = void 0;
var EventVideoStatus;
(function (EventVideoStatus) {
    EventVideoStatus["Preview"] = "preview";
    EventVideoStatus["SentToPublication"] = "sent-to-publication";
    EventVideoStatus["Publishing"] = "publishing";
    EventVideoStatus["Published"] = "published";
    EventVideoStatus["Uploaded"] = "uploaded";
    EventVideoStatus["Deleted"] = "deleted";
})(EventVideoStatus = exports.EventVideoStatus || (exports.EventVideoStatus = {}));
//# sourceMappingURL=event-video-status.js.map